import React from 'react';
import FormProgress from './FormProgress';
import FormNavigation from './FormNavigation';
import AutosaveIndicator from './AutosaveIndicator';
import ResumeForm from './ResumeForm';
import { CheckCircleIcon } from 'lucide-react';
interface Step {
  id: string;
  title: string;
}
interface IntakeFormLayoutProps {
  children: React.ReactNode;
  currentStep: number;
  totalSteps: number;
  title: string;
  onNext: () => void;
  onBack: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  steps?: Step[];
  isSubmitting?: boolean;
}
const IntakeFormLayout: React.FC<IntakeFormLayoutProps> = ({
  children,
  currentStep,
  totalSteps,
  title,
  onNext,
  onBack,
  isFirstStep,
  isLastStep,
  steps = [],
  isSubmitting = false
}) => {
  return <div className="min-h-screen bg-slate-50" data-id="element-186" data-mp="29pztu1z28tmv">
      {/* Header */}
      <header className="bg-navy-800 text-white py-6 shadow-md" data-id="element-187" data-mp="2nq0vvkr2a73x">
        <div className="container mx-auto px-4 md:px-6" data-id="element-188" data-mp="2jndvuwk8lfvn">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-189" data-mp="2joyqem6jwyti">
            <div data-id="element-190" data-mp="3swpauzxu5pse">
              <h1 className="text-2xl font-semibold" data-id="element-191" data-mp="3sx79u4bvui40">
                Estate Planning Intake Form
              </h1>
              <p className="text-slate-300 mt-1" data-id="element-192" data-mp="5qercxb81gcc">
                Complete your Will and Power of Attorney questionnaire
              </p>
            </div>
            <div className="mt-4 md:mt-0 flex items-center" data-id="element-193" data-mp="ar2sibt5zdka">
              <AutosaveIndicator data-id="element-194" data-mp="fp4b6vmohav8" />
              <div className="ml-4" data-id="element-195" data-mp="fo2xski6wcac">
                <ResumeForm data-id="element-196" data-mp="jq6blfsbzsys" />
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* Progress Bar */}
      <div className="container mx-auto px-4 md:px-6 pt-6" data-id="element-197" data-mp="ogmpf102dglo">
        <FormProgress currentStep={currentStep} totalSteps={totalSteps} data-id="element-198" data-mp="oj8yj52ls460" />
      </div>
      {/* Main Content with Sidebar */}
      <main className="container mx-auto px-4 md:px-6 py-8" data-id="element-199" data-mp="yflz8mwkfia9">
        <div className="flex flex-col lg:flex-row gap-6" data-id="element-200" data-mp="yczka27ci0i0">
          {/* Sidebar - Hidden on mobile, visible on desktop */}
          {steps.length > 0 && <aside className="hidden lg:block lg:w-64 flex-shrink-0" data-id="element-201" data-mp="dr2uztap382n">
              <div className="bg-white rounded-lg shadow-md p-4 sticky top-6" data-id="element-202" data-mp="8rgkvsq5y7y2">
                <h3 className="text-sm font-semibold text-navy-900 mb-4 uppercase tracking-wide" data-id="element-203" data-mp="nfuklusa9gae">
                  Form Sections
                </h3>
                <nav className="space-y-1" data-id="element-204" data-mp="iock17u69hpy">
                  {steps.map((step, index) => {
                const isActive = index === currentStep;
                const isCompleted = index < currentStep;
                return <div key={step.id} className={`flex items-start py-2 px-3 rounded-md transition-colors ${isActive ? 'bg-navy-50 border-l-4 border-navy-600' : isCompleted ? 'bg-slate-50' : 'hover:bg-slate-50'}`} data-id="element-205" data-mp="rjsnmgkqbb8q" data-mpi={index}>
                        <div className="flex items-center flex-1 min-w-0" data-id="element-206" data-mp="387wqdagq2msa">
                          <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium mr-3 ${isActive ? 'bg-navy-600 text-white' : isCompleted ? 'bg-green-100 text-green-700' : 'bg-slate-200 text-slate-600'}`} data-id="element-207" data-mp="338jtdww4zzbz">
                            {isCompleted ? <CheckCircleIcon size={14} data-id="element-208" data-mp="1dxog11ntpu68" /> : index + 1}
                          </div>
                          <span className={`text-sm ${isActive ? 'font-medium text-navy-900' : isCompleted ? 'text-slate-700' : 'text-slate-600'}`} data-id="element-209" data-mp="140jth0q2fwow">
                            {step.title}
                          </span>
                        </div>
                      </div>;
              })}
                </nav>
              </div>
            </aside>}
          {/* Form Content */}
          <div className="flex-1 min-w-0" data-id="element-210" data-mp="2pb0qhve39b1d">
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-211" data-mp="pa2iq34ya87f">
              <h2 className="text-2xl font-semibold text-navy-900 mb-6" data-id="element-212" data-mp="kcahgiif19qk">
                {title}
              </h2>
              {children}
            </div>
          </div>
        </div>
      </main>
      {/* Navigation */}
      <div className="sticky bottom-0 bg-white border-t border-slate-200 py-4 px-4 md:px-6 shadow-md" data-id="element-213" data-mp="bc5nba28g7uc">
        <div className="container mx-auto" data-id="element-214" data-mp="6db2k2kpg97l">
          <FormNavigation onNext={onNext} onBack={onBack} isFirstStep={isFirstStep} isLastStep={isLastStep} isSubmitting={isSubmitting} data-id="element-215" data-mp="6e42ajl8xyg8" />
        </div>
      </div>
    </div>;
};
export default IntakeFormLayout;